import styled from '@emotion/styled'

export const BlogContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const BlogTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  font-size: 2rem;
  color: #213054;
`

export const BlogRecentContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  color: #213054;
  font-size: 2rem;
`

export const BlogRecentItem = styled.div`
  padding: 10px;

  min-width: 200px;
  max-width: 400px;
  width: 30%;
  margin: 10px;
  border: 2px solid #f5f5f5;
  outline: 2px solid #0080fa;

  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  height: 510px;
`

export const BlogRecentItemTitle = styled.div`
  font-size: 2rem;
  color: #213054;

  :hover {
    color: #546da8;
  }
`

export const BlogRecentItemDescription = styled.div`
  margin-top: 10px;
`

export const BlogRecentItemDate = styled.div`
  margin-top: 10px;
  font-size: 1rem;
`

export const BlogRecentItemImage = styled.div`
  max-width: 450px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const PostContainer = styled.div`
  margin-left: 10%;
  margin-right: 10%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  color: #213054;
  font-size: 2rem;

  white-space: pre-line;
`

export const PostTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

export const PostDate = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

export const PostAuthor = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

export const PostImgContainer = styled.div``

export const PostSocialsContainer = styled.div``

export const PostContents = styled.div`
  p {
    margin-top: 30px;
    margin-bottom: 30px;
  }
  ul {
    margin-left: 30px;
    margin-top: 30px;
  }
  li {
    margin-top: 10px;
    margin-bottom: 10px;
  }
`
